import {NAMES} from "./constants";

export const lossDataNewSet3 = {
    "Jan 01 2025": {
        [NAMES.TROOPS]: 790800,
        [NAMES.TANKS]: 9672,
        [NAMES.BMP_BTR]: 20043,
        [NAMES.ARTA]: 21532,
        [NAMES.PPO]: 1032,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 330,
        [NAMES.UAV]: 21131,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 32675
    },
    "Jan 02 2025": {
        [NAMES.TROOPS]: 792170,
        [NAMES.TANKS]: 9676,
        [NAMES.BMP_BTR]: 20056,
        [NAMES.ARTA]: 21552,
        [NAMES.PPO]: 1032,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 330,
        [NAMES.UAV]: 21200,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 32729
    },
    "Jan 03 2025": {
        [NAMES.TROOPS]: 793250,
        [NAMES.TANKS]: 9677,
        [NAMES.BMP_BTR]: 20070,
        [NAMES.ARTA]: 21555,
        [NAMES.PPO]: 1032,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 330,
        [NAMES.UAV]: 21249,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 32770
    },
    "Jan 04 2025": {
        [NAMES.TROOPS]: 794760,
        [NAMES.TANKS]: 9679,
        [NAMES.BMP_BTR]: 20093,
        [NAMES.ARTA]: 21578,
        [NAMES.PPO]: 1032,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21356,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 32843
    },
    "Jan 05 2025": {
        [NAMES.TROOPS]: 796490,
        [NAMES.TANKS]: 9686,
        [NAMES.BMP_BTR]: 20119,
        [NAMES.ARTA]: 21603,
        [NAMES.PPO]: 1032,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21447,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 32940
    },
    "Jan 06 2025": {
        [NAMES.TROOPS]: 798040,
        [NAMES.TANKS]: 9700,
        [NAMES.BMP_BTR]: 20164,
        [NAMES.ARTA]: 21665,
        [NAMES.PPO]: 1034,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21625,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33056
    },
    "Jan 07 2025": {
        [NAMES.TROOPS]: 800010,
        [NAMES.TANKS]: 9710,
        [NAMES.BMP_BTR]: 20189,
        [NAMES.ARTA]: 21710,
        [NAMES.PPO]: 1038,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21708,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33226
    },
    "Jan 08 2025": {
        [NAMES.TROOPS]: 801670,
        [NAMES.TANKS]: 9714,
        [NAMES.BMP_BTR]: 20205,
        [NAMES.ARTA]: 21729,
        [NAMES.PPO]: 1038,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21727,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33307
    },
    "Jan 09 2025": {
        [NAMES.TROOPS]: 803100,
        [NAMES.TANKS]: 9731,
        [NAMES.BMP_BTR]: 20221,
        [NAMES.ARTA]: 21765,
        [NAMES.PPO]: 1038,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21813,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33387
    },
    "Jan 10 2025": {
        [NAMES.TROOPS]: 804930,
        [NAMES.TANKS]: 9741,
        [NAMES.BMP_BTR]: 20253,
        [NAMES.ARTA]: 21789,
        [NAMES.PPO]: 1041,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21884,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33473
    },
    "Jan 11 2025": {
        [NAMES.TROOPS]: 806500,
        [NAMES.TANKS]: 9751,
        [NAMES.BMP_BTR]: 20271,
        [NAMES.ARTA]: 21817,
        [NAMES.PPO]: 1042,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 21958,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33534
    },
    "Jan 12 2025": {
        [NAMES.TROOPS]: 808250,
        [NAMES.TANKS]: 9756,
        [NAMES.BMP_BTR]: 20289,
        [NAMES.ARTA]: 21839,
        [NAMES.PPO]: 1042,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22021,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33598
    },
    "Jan 13 2025": {
        [NAMES.TROOPS]: 809760,
        [NAMES.TANKS]: 9764,
        [NAMES.BMP_BTR]: 20315,
        [NAMES.ARTA]: 21876,
        [NAMES.PPO]: 1044,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22204,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33708
    },
    "Jan 14 2025": {
        [NAMES.TROOPS]: 811090,
        [NAMES.TANKS]: 9767,
        [NAMES.BMP_BTR]: 20326,
        [NAMES.ARTA]: 21923,
        [NAMES.PPO]: 1044,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22276,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33791
    },
    "Jan 15 2025": {
        [NAMES.TROOPS]: 812670,
        [NAMES.TANKS]: 9780,
        [NAMES.BMP_BTR]: 20348,
        [NAMES.ARTA]: 21975,
        [NAMES.PPO]: 1046,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22383,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 33995
    },
    "Jan 16 2025": {
        [NAMES.TROOPS]: 814150,
        [NAMES.TANKS]: 9791,
        [NAMES.BMP_BTR]: 20368,
        [NAMES.ARTA]: 22015,
        [NAMES.PPO]: 1046,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22503,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34132
    },
    "Jan 17 2025": {
        [NAMES.TROOPS]: 815820,
        [NAMES.TANKS]: 9803,
        [NAMES.BMP_BTR]: 20381,
        [NAMES.ARTA]: 22019,
        [NAMES.PPO]: 1046,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22566,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34256
    },
    "Jan 18 2025": {
        [NAMES.TROOPS]: 817160,
        [NAMES.TANKS]: 9803,
        [NAMES.BMP_BTR]: 20394,
        [NAMES.ARTA]: 22040,
        [NAMES.PPO]: 1046,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22579,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34325
    },
    "Jan 19 2025": {
        [NAMES.TROOPS]: 818740,
        [NAMES.TANKS]: 9811,
        [NAMES.BMP_BTR]: 20412,
        [NAMES.ARTA]: 22055,
        [NAMES.PPO]: 1046,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22615,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34401
    },
    "Jan 20 2025": {
        [NAMES.TROOPS]: 820430,
        [NAMES.TANKS]: 9821,
        [NAMES.BMP_BTR]: 20454,
        [NAMES.ARTA]: 22074,
        [NAMES.PPO]: 1049,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22768,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34488
    },
    "Jan 21 2025": {
        [NAMES.TROOPS]: 822030,
        [NAMES.TANKS]: 9833,
        [NAMES.BMP_BTR]: 20477,
        [NAMES.ARTA]: 22134,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 22898,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34682
    },
    "Jan 22 2025": {
        [NAMES.TROOPS]: 823980,
        [NAMES.TANKS]: 9844,
        [NAMES.BMP_BTR]: 20485,
        [NAMES.ARTA]: 22194,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23039,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34837
    },
    "Jan 23 2025": {
        [NAMES.TROOPS]: 825320,
        [NAMES.TANKS]: 9850,
        [NAMES.BMP_BTR]: 20497,
        [NAMES.ARTA]: 22256,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23111,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34905
    },
    "Jan 24 2025": {
        [NAMES.TROOPS]: 826820,
        [NAMES.TANKS]: 9852,
        [NAMES.BMP_BTR]: 20508,
        [NAMES.ARTA]: 22295,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23162,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 34992
    },
    "Jan 25 2025": {
        [NAMES.TROOPS]: 828470,
        [NAMES.TANKS]: 9859,
        [NAMES.BMP_BTR]: 20545,
        [NAMES.ARTA]: 22309,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23213,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35071
    },
    "Jan 26 2025": {
        [NAMES.TROOPS]: 830190,
        [NAMES.TANKS]: 9868,
        [NAMES.BMP_BTR]: 20549,
        [NAMES.ARTA]: 22323,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23253,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35124
    },
    "Jan 27 2025": {
        [NAMES.TROOPS]: 831620,
        [NAMES.TANKS]: 9871,
        [NAMES.BMP_BTR]: 20561,
        [NAMES.ARTA]: 22339,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23327,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35183
    },
    "Jan 28 2025": {
        [NAMES.TROOPS]: 833000,
        [NAMES.TANKS]: 9876,
        [NAMES.BMP_BTR]: 20573,
        [NAMES.ARTA]: 22366,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23399,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35269
    },
    "Jan 29 2025": {
        [NAMES.TROOPS]: 834670,
        [NAMES.TANKS]: 9886,
        [NAMES.BMP_BTR]: 20597,
        [NAMES.ARTA]: 22395,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23456,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35366
    },
    "Jan 30 2025": {
        [NAMES.TROOPS]: 835940,
        [NAMES.TANKS]: 9890,
        [NAMES.BMP_BTR]: 20614,
        [NAMES.ARTA]: 22412,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23510,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35451
    },
    "Jan 31 2025": {
        [NAMES.TROOPS]: 837610,
        [NAMES.TANKS]: 9893,
        [NAMES.BMP_BTR]: 20631,
        [NAMES.ARTA]: 22445,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23573,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35552
    },
    "Feb 01 2025": {
        [NAMES.TROOPS]: 839040,
        [NAMES.TANKS]: 9902,
        [NAMES.BMP_BTR]: 20653,
        [NAMES.ARTA]: 22493,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23694,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35629
    },
    "Feb 02 2025": {
        [NAMES.TROOPS]: 840360,
        [NAMES.TANKS]: 9908,
        [NAMES.BMP_BTR]: 20667,
        [NAMES.ARTA]: 22538,
        [NAMES.PPO]: 1050,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23793,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35709
    },
    "Feb 03 2025": {
        [NAMES.TROOPS]: 841660,
        [NAMES.TANKS]: 9920,
        [NAMES.BMP_BTR]: 20685,
        [NAMES.ARTA]: 22598,
        [NAMES.PPO]: 1053,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 23911,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35798
    },
    "Feb 04 2025": {
        [NAMES.TROOPS]: 842930,
        [NAMES.TANKS]: 9938,
        [NAMES.BMP_BTR]: 20709,
        [NAMES.ARTA]: 22655,
        [NAMES.PPO]: 1053,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24003,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 35921
    },
    "Feb 05 2025": {
        [NAMES.TROOPS]: 844070,
        [NAMES.TANKS]: 9947,
        [NAMES.BMP_BTR]: 20721,
        [NAMES.ARTA]: 22707,
        [NAMES.PPO]: 1053,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24102,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36078
    },
    "Feb 06 2025": {
        [NAMES.TROOPS]: 845310,
        [NAMES.TANKS]: 9965,
        [NAMES.BMP_BTR]: 20737,
        [NAMES.ARTA]: 22753,
        [NAMES.PPO]: 1055,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24185,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36211
    },
    "Feb 07 2025": {
        [NAMES.TROOPS]: 846650,
        [NAMES.TANKS]: 9975,
        [NAMES.BMP_BTR]: 20755,
        [NAMES.ARTA]: 22785,
        [NAMES.PPO]: 1056,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24301,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36307
    },
    "Feb 08 2025": {
        [NAMES.TROOPS]: 847860,
        [NAMES.TANKS]: 9981,
        [NAMES.BMP_BTR]: 20777,
        [NAMES.ARTA]: 22820,
        [NAMES.PPO]: 1056,
        [NAMES.JETS]: 369,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24403,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36402
    },
    "Feb 09 2025": {
        [NAMES.TROOPS]: 849320,
        [NAMES.TANKS]: 9992,
        [NAMES.BMP_BTR]: 20797,
        [NAMES.ARTA]: 22844,
        [NAMES.PPO]: 1056,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24486,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36529
    },
    "Feb 10 2025": {
        [NAMES.TROOPS]: 850490,
        [NAMES.TANKS]: 10001,
        [NAMES.BMP_BTR]: 20813,
        [NAMES.ARTA]: 22879,
        [NAMES.PPO]: 1059,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24623,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36638
    },
    "Feb 11 2025": {
        [NAMES.TROOPS]: 851880,
        [NAMES.TANKS]: 10014,
        [NAMES.BMP_BTR]: 20844,
        [NAMES.ARTA]: 22923,
        [NAMES.PPO]: 1060,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24755,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36807
    },
    "Feb 12 2025": {
        [NAMES.TROOPS]: 853030,
        [NAMES.TANKS]: 10023,
        [NAMES.BMP_BTR]: 20871,
        [NAMES.ARTA]: 22976,
        [NAMES.PPO]: 1061,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 24919,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 36928
    },
    "Feb 13 2025": {
        [NAMES.TROOPS]: 854280,
        [NAMES.TANKS]: 10040,
        [NAMES.BMP_BTR]: 20894,
        [NAMES.ARTA]: 23034,
        [NAMES.PPO]: 1063,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 25072,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37096
    },
    "Feb 14 2025": {
        [NAMES.TROOPS]: 855480,
        [NAMES.TANKS]: 10057,
        [NAMES.BMP_BTR]: 20910,
        [NAMES.ARTA]: 23115,
        [NAMES.PPO]: 1066,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 25224,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37252
    },
    "Feb 15 2025": {
        [NAMES.TROOPS]: 856660,
        [NAMES.TANKS]: 10068,
        [NAMES.BMP_BTR]: 20927,
        [NAMES.ARTA]: 23174,
        [NAMES.PPO]: 1067,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 25341,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37379
    },
    "Feb 16 2025": {
        [NAMES.TROOPS]: 858390,
        [NAMES.TANKS]: 10073,
        [NAMES.BMP_BTR]: 21011,
        [NAMES.ARTA]: 23185,
        [NAMES.PPO]: 1067,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 25377,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37456
    },
    "Feb 17 2025": {
        [NAMES.TROOPS]: 859920,
        [NAMES.TANKS]: 10089,
        [NAMES.BMP_BTR]: 21063,
        [NAMES.ARTA]: 23222,
        [NAMES.PPO]: 1067,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 25505,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37605
    },
    "Feb 18 2025": {
        [NAMES.TROOPS]: 861090,
        [NAMES.TANKS]: 10101,
        [NAMES.BMP_BTR]: 21075,
        [NAMES.ARTA]: 23275,
        [NAMES.PPO]: 1068,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 25686,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37679
    },
    "Feb 19 2025": {
        [NAMES.TROOPS]: 862390,
        [NAMES.TANKS]: 10120,
        [NAMES.BMP_BTR]: 21098,
        [NAMES.ARTA]: 23347,
        [NAMES.PPO]: 1072,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 25861,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37825
    },
    "Feb 20 2025": {
        [NAMES.TROOPS]: 863580,
        [NAMES.TANKS]: 10134,
        [NAMES.BMP_BTR]: 21112,
        [NAMES.ARTA]: 23410,
        [NAMES.PPO]: 1078,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 26021,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 37961
    },
    "Feb 21 2025": {
        [NAMES.TROOPS]: 864860,
        [NAMES.TANKS]: 10146,
        [NAMES.BMP_BTR]: 21130,
        [NAMES.ARTA]: 23462,
        [NAMES.PPO]: 1080,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 26156,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38104
    },
    "Feb 22 2025": {
        [NAMES.TROOPS]: 866000,
        [NAMES.TANKS]: 10161,
        [NAMES.BMP_BTR]: 21139,
        [NAMES.ARTA]: 23528,
        [NAMES.PPO]: 1080,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 26311,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38243
    },
    "Feb 23 2025": {
        [NAMES.TROOPS]: 867180,
        [NAMES.TANKS]: 10168,
        [NAMES.BMP_BTR]: 21151,
        [NAMES.ARTA]: 23582,
        [NAMES.PPO]: 1081,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 26428,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38334
    },
    "Feb 24 2025": {
        [NAMES.TROOPS]: 868230,
        [NAMES.TANKS]: 10177,
        [NAMES.BMP_BTR]: 21157,
        [NAMES.ARTA]: 23626,
        [NAMES.PPO]: 1081,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 26445,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38444
    },
    "Feb 25 2025": {
        [NAMES.TROOPS]: 869530,
        [NAMES.TANKS]: 10182,
        [NAMES.BMP_BTR]: 21168,
        [NAMES.ARTA]: 23652,
        [NAMES.PPO]: 1083,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 26767,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38582
    },
    "Feb 26 2025": {
        [NAMES.TROOPS]: 870700,
        [NAMES.TANKS]: 10201,
        [NAMES.BMP_BTR]: 21183,
        [NAMES.ARTA]: 23686,
        [NAMES.PPO]: 1085,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 26961,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38702
    },
    "Feb 27 2025": {
        [NAMES.TROOPS]: 871850,
        [NAMES.TANKS]: 10209,
        [NAMES.BMP_BTR]: 21196,
        [NAMES.ARTA]: 23755,
        [NAMES.PPO]: 1086,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27102,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38842
    },
    "Feb 28 2025": {
        [NAMES.TROOPS]: 874560,
        [NAMES.TANKS]: 10222,
        [NAMES.BMP_BTR]: 21234,
        [NAMES.ARTA]: 23847,
        [NAMES.PPO]: 1087,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27274,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 38994
    },
    "Mar 01 2025": {
        [NAMES.TROOPS]: 875610,
        [NAMES.TANKS]: 10233,
        [NAMES.BMP_BTR]: 21249,
        [NAMES.ARTA]: 23908,
        [NAMES.PPO]: 1088,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27402,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39101
    },
    "Mar 02 2025": {
        [NAMES.TROOPS]: 876720,
        [NAMES.TANKS]: 10241,
        [NAMES.BMP_BTR]: 21274,
        [NAMES.ARTA]: 23959,
        [NAMES.PPO]: 1091,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27594,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39218
    },
    "Mar 03 2025": {
        [NAMES.TROOPS]: 878070,
        [NAMES.TANKS]: 10252,
        [NAMES.BMP_BTR]: 21290,
        [NAMES.ARTA]: 24019,
        [NAMES.PPO]: 1093,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27655,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39327
    },
    "Mar 04 2025": {
        [NAMES.TROOPS]: 879410,
        [NAMES.TANKS]: 10255,
        [NAMES.BMP_BTR]: 21298,
        [NAMES.ARTA]: 24064,
        [NAMES.PPO]: 1094,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27741,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39428
    },
    "Mar 05 2025": {
        [NAMES.TROOPS]: 880660,
        [NAMES.TANKS]: 10256,
        [NAMES.BMP_BTR]: 21304,
        [NAMES.ARTA]: 24087,
        [NAMES.PPO]: 1094,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27849,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39512
    },
    "Mar 06 2025": {
        [NAMES.TROOPS]: 881800,
        [NAMES.TANKS]: 10261,
        [NAMES.BMP_BTR]: 21311,
        [NAMES.ARTA]: 24108,
        [NAMES.PPO]: 1096,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 27929,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39606
    },
    "Mar 07 2025": {
        [NAMES.TROOPS]: 882950,
        [NAMES.TANKS]: 10264,
        [NAMES.BMP_BTR]: 21334,
        [NAMES.ARTA]: 24124,
        [NAMES.PPO]: 1096,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 28024,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39678
    },
    "Mar 08 2025": {
        [NAMES.TROOPS]: 883950,
        [NAMES.TANKS]: 10268,
        [NAMES.BMP_BTR]: 21346,
        [NAMES.ARTA]: 24148,
        [NAMES.PPO]: 1099,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 28172,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39791
    },
    "Mar 09 2025": {
        [NAMES.TROOPS]: 885130,
        [NAMES.TANKS]: 10274,
        [NAMES.BMP_BTR]: 21360,
        [NAMES.ARTA]: 24206,
        [NAMES.PPO]: 1101,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 28362,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 39933
    },
    "Mar 10 2025": {
        [NAMES.TROOPS]: 886320,
        [NAMES.TANKS]: 10292,
        [NAMES.BMP_BTR]: 21400,
        [NAMES.ARTA]: 24271,
        [NAMES.PPO]: 1102,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 28603,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40071
    },
    "Mar 11 2025": {
        [NAMES.TROOPS]: 887620,
        [NAMES.TANKS]: 10303,
        [NAMES.BMP_BTR]: 21423,
        [NAMES.ARTA]: 24346,
        [NAMES.PPO]: 1103,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 28801,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40205
    },
    "Mar 12 2025": {
        [NAMES.TROOPS]: 889050,
        [NAMES.TANKS]: 10306,
        [NAMES.BMP_BTR]: 21430,
        [NAMES.ARTA]: 24390,
        [NAMES.PPO]: 1103,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 28912,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40274
    },
    "Mar 13 2025": {
        [NAMES.TROOPS]: 890250,
        [NAMES.TANKS]: 10307,
        [NAMES.BMP_BTR]: 21432,
        [NAMES.ARTA]: 24409,
        [NAMES.PPO]: 1103,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 28983,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40355
    },
    "Mar 14 2025": {
        [NAMES.TROOPS]: 891660,
        [NAMES.TANKS]: 10313,
        [NAMES.BMP_BTR]: 21443,
        [NAMES.ARTA]: 24455,
        [NAMES.PPO]: 1103,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 29136,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40469
    },
    "Mar 15 2025": {
        [NAMES.TROOPS]: 892840,
        [NAMES.TANKS]: 10315,
        [NAMES.BMP_BTR]: 21458,
        [NAMES.ARTA]: 24483,
        [NAMES.PPO]: 1103,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 29233,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40571
    },
    "Mar 16 2025": {
        [NAMES.TROOPS]: 894240,
        [NAMES.TANKS]: 10325,
        [NAMES.BMP_BTR]: 21478,
        [NAMES.ARTA]: 24561,
        [NAMES.PPO]: 1104,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 29413,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40684
    },
    "Mar 17 2025": {
        [NAMES.TROOPS]: 895450,
        [NAMES.TANKS]: 10344,
        [NAMES.BMP_BTR]: 21488,
        [NAMES.ARTA]: 24598,
        [NAMES.PPO]: 1104,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 29467,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40785
    },
    "Mar 18 2025": {
        [NAMES.TROOPS]: 897010,
        [NAMES.TANKS]: 10352,
        [NAMES.BMP_BTR]: 21509,
        [NAMES.ARTA]: 24640,
        [NAMES.PPO]: 1107,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 29616,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 40892
    },
    "Mar 19 2025": {
        [NAMES.TROOPS]: 898070,
        [NAMES.TANKS]: 10364,
        [NAMES.BMP_BTR]: 21523,
        [NAMES.ARTA]: 24704,
        [NAMES.PPO]: 1107,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 29716,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41003
    },
    "Mar 20 2025": {
        [NAMES.TROOPS]: 899470,
        [NAMES.TANKS]: 10377,
        [NAMES.BMP_BTR]: 21561,
        [NAMES.ARTA]: 24747,
        [NAMES.PPO]: 1110,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 29895,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41094
    },
    "Mar 21 2025": {
        [NAMES.TROOPS]: 900800,
        [NAMES.TANKS]: 10394,
        [NAMES.BMP_BTR]: 21589,
        [NAMES.ARTA]: 24848,
        [NAMES.PPO]: 1111,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 30080,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41259
    },
    "Mar 22 2025": {
        [NAMES.TROOPS]: 902010,
        [NAMES.TANKS]: 10403,
        [NAMES.BMP_BTR]: 21609,
        [NAMES.ARTA]: 24944,
        [NAMES.PPO]: 1111,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 30338,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41425
    },
    "Mar 23 2025": {
        [NAMES.TROOPS]: 903480,
        [NAMES.TANKS]: 10412,
        [NAMES.BMP_BTR]: 21636,
        [NAMES.ARTA]: 25048,
        [NAMES.PPO]: 1116,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 331,
        [NAMES.UAV]: 30495,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41610
    },
    "Mar 24 2025": {
        [NAMES.TROOPS]: 904760,
        [NAMES.TANKS]: 10420,
        [NAMES.BMP_BTR]: 21652,
        [NAMES.ARTA]: 25129,
        [NAMES.PPO]: 1117,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 30641,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41726
    },
    "Mar 25 2025": {
        [NAMES.TROOPS]: 905940,
        [NAMES.TANKS]: 10425,
        [NAMES.BMP_BTR]: 21670,
        [NAMES.ARTA]: 25190,
        [NAMES.PPO]: 1117,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 30759,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41824
    },
    "Mar 26 2025": {
        [NAMES.TROOPS]: 907220,
        [NAMES.TANKS]: 10430,
        [NAMES.BMP_BTR]: 21685,
        [NAMES.ARTA]: 25207,
        [NAMES.PPO]: 1117,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 30818,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 41901
    },
    "Mar 27 2025": {
        [NAMES.TROOPS]: 908890,
        [NAMES.TANKS]: 10438,
        [NAMES.BMP_BTR]: 21701,
        [NAMES.ARTA]: 25265,
        [NAMES.PPO]: 1118,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 30926,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42070
    },
    "Mar 28 2025": {
        [NAMES.TROOPS]: 910750,
        [NAMES.TANKS]: 10455,
        [NAMES.BMP_BTR]: 21762,
        [NAMES.ARTA]: 25387,
        [NAMES.PPO]: 1119,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31070,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42280
    },
    "Mar 29 2025": {
        [NAMES.TROOPS]: 912490,
        [NAMES.TANKS]: 10478,
        [NAMES.BMP_BTR]: 21796,
        [NAMES.ARTA]: 25451,
        [NAMES.PPO]: 1122,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31234,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42398
    },
    "Mar 30 2025": {
        [NAMES.TROOPS]: 914000,
        [NAMES.TANKS]: 10492,
        [NAMES.BMP_BTR]: 21816,
        [NAMES.ARTA]: 25507,
        [NAMES.PPO]: 1122,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31345,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42528
    },
    "Mar 31 2025": {
        [NAMES.TROOPS]: 915230,
        [NAMES.TANKS]: 10496,
        [NAMES.BMP_BTR]: 21819,
        [NAMES.ARTA]: 25537,
        [NAMES.PPO]: 1123,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31416,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42593
    },
    "Apr 1 2025": {
        [NAMES.TROOPS]: 916770,
        [NAMES.TANKS]: 10505,
        [NAMES.BMP_BTR]: 21856,
        [NAMES.ARTA]: 25552,
        [NAMES.PPO]: 1123,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31462,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42646
    },
    "Apr 2 2025": {
        [NAMES.TROOPS]: 918180,
        [NAMES.TANKS]: 10515,
        [NAMES.BMP_BTR]: 21880,
        [NAMES.ARTA]: 25576,
        [NAMES.PPO]: 1123,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31505,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42687
    },
    "Apr 3 2025": {
        [NAMES.TROOPS]: 919570,
        [NAMES.TANKS]: 10521,
        [NAMES.BMP_BTR]: 21902,
        [NAMES.ARTA]: 25625,
        [NAMES.PPO]: 1123,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31597,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42775
    },
    "Apr 4 2025": {
        [NAMES.TROOPS]: 920950,
        [NAMES.TANKS]: 10528,
        [NAMES.BMP_BTR]: 21932,
        [NAMES.ARTA]: 25663,
        [NAMES.PPO]: 1123,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31669,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42841
    },
    "Apr 5 2025": {
        [NAMES.TROOPS]: 922340,
        [NAMES.TANKS]: 10541,
        [NAMES.BMP_BTR]: 21952,
        [NAMES.ARTA]: 25730,
        [NAMES.PPO]: 1124,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31778,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 42954
    },
    "Apr 6 2025": {
        [NAMES.TROOPS]: 923670,
        [NAMES.TANKS]: 10554,
        [NAMES.BMP_BTR]: 21972,
        [NAMES.ARTA]: 25786,
        [NAMES.PPO]: 1124,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31846,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43050
    },
    "Apr 7 2025": {
        [NAMES.TROOPS]: 925020,
        [NAMES.TANKS]: 10567,
        [NAMES.BMP_BTR]: 21997,
        [NAMES.ARTA]: 25817,
        [NAMES.PPO]: 1124,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31874,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43120
    },
    "Apr 8 2025": {
        [NAMES.TROOPS]: 926310,
        [NAMES.TANKS]: 10572,
        [NAMES.BMP_BTR]: 22011,
        [NAMES.ARTA]: 25860,
        [NAMES.PPO]: 1126,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31917,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43227
    },
    "Apr 9 2025": {
        [NAMES.TROOPS]: 927580,
        [NAMES.TANKS]: 10576,
        [NAMES.BMP_BTR]: 22021,
        [NAMES.ARTA]: 25912,
        [NAMES.PPO]: 1127,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 31973,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43345
    },
    "Apr 10 2025": {
        [NAMES.TROOPS]: 929000,
        [NAMES.TANKS]: 10579,
        [NAMES.BMP_BTR]: 22033,
        [NAMES.ARTA]: 25982,
        [NAMES.PPO]: 1127,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32078,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43514
    },
    "Apr 11 2025": {
        [NAMES.TROOPS]: 930210,
        [NAMES.TANKS]: 10580,
        [NAMES.BMP_BTR]: 22048,
        [NAMES.ARTA]: 26043,
        [NAMES.PPO]: 1127,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32200,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43679
    },
    "Apr 12 2025": {
        [NAMES.TROOPS]: 931450,
        [NAMES.TANKS]: 10591,
        [NAMES.BMP_BTR]: 22055,
        [NAMES.ARTA]: 26092,
        [NAMES.PPO]: 1127,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32278,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43807
    },
    "Apr 13 2025": {
        [NAMES.TROOPS]: 932670,
        [NAMES.TANKS]: 10603,
        [NAMES.BMP_BTR]: 22088,
        [NAMES.ARTA]: 26163,
        [NAMES.PPO]: 1128,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32425,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 43950
    },
    "Apr 14 2025": {
        [NAMES.TROOPS]: 933980,
        [NAMES.TANKS]: 10622,
        [NAMES.BMP_BTR]: 22130,
        [NAMES.ARTA]: 26222,
        [NAMES.PPO]: 1130,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32544,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 44129
    },
    "Apr 15 2025": {
        [NAMES.TROOPS]: 935160,
        [NAMES.TANKS]: 10629,
        [NAMES.BMP_BTR]: 22150,
        [NAMES.ARTA]: 26290,
        [NAMES.PPO]: 1132,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32691,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 44339
    },
    "Apr 16 2025": {
        [NAMES.TROOPS]: 936210,
        [NAMES.TANKS]: 10638,
        [NAMES.BMP_BTR]: 22163,
        [NAMES.ARTA]: 26377,
        [NAMES.PPO]: 1132,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32837,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 44472
    },
    "Apr 17 2025": {
        [NAMES.TROOPS]: 937440,
        [NAMES.TANKS]: 10654,
        [NAMES.BMP_BTR]: 22217,
        [NAMES.ARTA]: 26442,
        [NAMES.PPO]: 1135,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 32925,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 44642
    },
    "Apr 18 2025": {
        [NAMES.TROOPS]: 938970,
        [NAMES.TANKS]: 10662,
        [NAMES.BMP_BTR]: 22257,
        [NAMES.ARTA]: 26530,
        [NAMES.PPO]: 1136,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33065,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 44954
    },
    "Apr 19 2025": {
        [NAMES.TROOPS]: 940150,
        [NAMES.TANKS]: 10676,
        [NAMES.BMP_BTR]: 22266,
        [NAMES.ARTA]: 26600,
        [NAMES.PPO]: 1139,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33176,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 45162
    },
    "Apr 20 2025": {
        [NAMES.TROOPS]: 941100,
        [NAMES.TANKS]: 10677,
        [NAMES.BMP_BTR]: 22271,
        [NAMES.ARTA]: 26649,
        [NAMES.PPO]: 1139,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33240,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 45274
    },
    "Apr 21 2025": {
        [NAMES.TROOPS]: 941770,
        [NAMES.TANKS]: 10679,
        [NAMES.BMP_BTR]: 22273,
        [NAMES.ARTA]: 26659,
        [NAMES.PPO]: 1139,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33270,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 45324
    },
    "Apr 22 2025": {
        [NAMES.TROOPS]: 943060,
        [NAMES.TANKS]: 10683,
        [NAMES.BMP_BTR]: 22296,
        [NAMES.ARTA]: 26689,
        [NAMES.PPO]: 1140,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33388,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 45458
    },
    "Apr 23 2025": {
        [NAMES.TROOPS]: 944270,
        [NAMES.TANKS]: 10691,
        [NAMES.BMP_BTR]: 22307,
        [NAMES.ARTA]: 26774,
        [NAMES.PPO]: 1141,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33526,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 45621
    },
    "Apr 24 2025": {
        [NAMES.TROOPS]: 945330,
        [NAMES.TANKS]: 10694,
        [NAMES.BMP_BTR]: 22312,
        [NAMES.ARTA]: 26823,
        [NAMES.PPO]: 1141,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33660,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 45755
    },
    "Apr 25 2025": {
        [NAMES.TROOPS]: 946500,
        [NAMES.TANKS]: 10703,
        [NAMES.BMP_BTR]: 22315,
        [NAMES.ARTA]: 26895,
        [NAMES.PPO]: 1144,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33779,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 45906
    },
    "Apr 26 2025": {
        [NAMES.TROOPS]: 947610,
        [NAMES.TANKS]: 10711,
        [NAMES.BMP_BTR]: 22320,
        [NAMES.ARTA]: 26965,
        [NAMES.PPO]: 1145,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 33897,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 46051
    },
    "Apr 27 2025": {
        [NAMES.TROOPS]: 948640,
        [NAMES.TANKS]: 10719,
        [NAMES.BMP_BTR]: 22325,
        [NAMES.ARTA]: 27007,
        [NAMES.PPO]: 1145,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34011,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 46187
    },
    "Apr 28 2025": {
        [NAMES.TROOPS]: 949800,
        [NAMES.TANKS]: 10723,
        [NAMES.BMP_BTR]: 22338,
        [NAMES.ARTA]: 27038,
        [NAMES.PPO]: 1145,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34083,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 46292
    },
    "Apr 29 2025": {
        [NAMES.TROOPS]: 950860,
        [NAMES.TANKS]: 10728,
        [NAMES.BMP_BTR]: 22352,
        [NAMES.ARTA]: 27080,
        [NAMES.PPO]: 1146,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34177,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 46432
    },
    "Apr 30 2025": {
        [NAMES.TROOPS]: 951960,
        [NAMES.TANKS]: 10729,
        [NAMES.BMP_BTR]: 22353,
        [NAMES.ARTA]: 27091,
        [NAMES.PPO]: 1146,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34289,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 46611
    },
    "May 01 2025": {
        [NAMES.TROOPS]: 953190,
        [NAMES.TANKS]: 10732,
        [NAMES.BMP_BTR]: 22364,
        [NAMES.ARTA]: 27136,
        [NAMES.PPO]: 1148,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34401,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 46750
    },
    "May 02 2025": {
        [NAMES.TROOPS]: 954300,
        [NAMES.TANKS]: 10741,
        [NAMES.BMP_BTR]: 22369,
        [NAMES.ARTA]: 27186,
        [NAMES.PPO]: 1152,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34539,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 46882
    },
    "May 03 2025": {
        [NAMES.TROOPS]: 955470,
        [NAMES.TANKS]: 10745,
        [NAMES.BMP_BTR]: 22369,
        [NAMES.ARTA]: 27234,
        [NAMES.PPO]: 1153,
        [NAMES.JETS]: 370,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34665,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47003
    },
    "May 04 2025": {
        [NAMES.TROOPS]: 956810,
        [NAMES.TANKS]: 10758,
        [NAMES.BMP_BTR]: 22403,
        [NAMES.ARTA]: 27327,
        [NAMES.PPO]: 1155,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34860,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47141
    },
    "May 05 2025": {
        [NAMES.TROOPS]: 958070,
        [NAMES.TANKS]: 10763,
        [NAMES.BMP_BTR]: 22411,
        [NAMES.ARTA]: 27370,
        [NAMES.PPO]: 1155,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 34997,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47250
    },
    "May 06 2025": {
        [NAMES.TROOPS]: 959500,
        [NAMES.TANKS]: 10766,
        [NAMES.BMP_BTR]: 22416,
        [NAMES.ARTA]: 27431,
        [NAMES.PPO]: 1155,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35142,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47353
    },
    "May 07 2025": {
        [NAMES.TROOPS]: 960770,
        [NAMES.TANKS]: 10780,
        [NAMES.BMP_BTR]: 22419,
        [NAMES.ARTA]: 27502,
        [NAMES.PPO]: 1155,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35266,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47484
    },
    "May 08 2025": {
        [NAMES.TROOPS]: 961970,
        [NAMES.TANKS]: 10782,
        [NAMES.BMP_BTR]: 22429,
        [NAMES.ARTA]: 27552,
        [NAMES.PPO]: 1156,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35407,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47604
    },
    "May 09 2025": {
        [NAMES.TROOPS]: 963270,
        [NAMES.TANKS]: 10786,
        [NAMES.BMP_BTR]: 22433,
        [NAMES.ARTA]: 27588,
        [NAMES.PPO]: 1157,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35446,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47724
    },
    "May 10 2025": {
        [NAMES.TROOPS]: 964580,
        [NAMES.TANKS]: 10790,
        [NAMES.BMP_BTR]: 22440,
        [NAMES.ARTA]: 27637,
        [NAMES.PPO]: 1158,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35482,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47830
    },
    "May 11 2025": {
        [NAMES.TROOPS]: 965890,
        [NAMES.TANKS]: 10792,
        [NAMES.BMP_BTR]: 22446,
        [NAMES.ARTA]: 27670,
        [NAMES.PPO]: 1159,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35537,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 47947
    },
    "May 12 2025": {
        [NAMES.TROOPS]: 967060,
        [NAMES.TANKS]: 10800,
        [NAMES.BMP_BTR]: 22473,
        [NAMES.ARTA]: 27718,
        [NAMES.PPO]: 1162,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35678,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48118
    },
    "May 13 2025": {
        [NAMES.TROOPS]: 968130,
        [NAMES.TANKS]: 10802,
        [NAMES.BMP_BTR]: 22487,
        [NAMES.ARTA]: 27780,
        [NAMES.PPO]: 1162,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35778,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48256
    },
    "May 14 2025": {
        [NAMES.TROOPS]: 969370,
        [NAMES.TANKS]: 10804,
        [NAMES.BMP_BTR]: 22501,
        [NAMES.ARTA]: 27827,
        [NAMES.PPO]: 1165,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 335,
        [NAMES.UAV]: 35860,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48382
    },
    "May 15 2025": {
        [NAMES.TROOPS]: 970590,
        [NAMES.TANKS]: 10812,
        [NAMES.BMP_BTR]: 22514,
        [NAMES.ARTA]: 27872,
        [NAMES.PPO]: 1166,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36000,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48547
    },
    "May 16 2025": {
        [NAMES.TROOPS]: 971690,
        [NAMES.TANKS]: 10825,
        [NAMES.BMP_BTR]: 22546,
        [NAMES.ARTA]: 27908,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36123,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48713
    },
    "May 17 2025": {
        [NAMES.TROOPS]: 972600,
        [NAMES.TANKS]: 10831,
        [NAMES.BMP_BTR]: 22553,
        [NAMES.ARTA]: 27942,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36278,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48809
    },
    "May 18 2025": {
        [NAMES.TROOPS]: 973730,
        [NAMES.TANKS]: 10832,
        [NAMES.BMP_BTR]: 22557,
        [NAMES.ARTA]: 27980,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36385,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48900
    },
    "May 19 2025": {
        [NAMES.TROOPS]: 974770,
        [NAMES.TANKS]: 10833,
        [NAMES.BMP_BTR]: 22562,
        [NAMES.ARTA]: 28009,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36503,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 48988
    },
    "May 20 2025": {
        [NAMES.TROOPS]: 975800,
        [NAMES.TANKS]: 10834,
        [NAMES.BMP_BTR]: 22567,
        [NAMES.ARTA]: 28067,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36621,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49093
    },
    "May 21 2025": {
        [NAMES.TROOPS]: 976780,
        [NAMES.TANKS]: 10835,
        [NAMES.BMP_BTR]: 22569,
        [NAMES.ARTA]: 28090,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36692,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49169
    },
    "May 22 2025": {
        [NAMES.TROOPS]: 977650,
        [NAMES.TANKS]: 10839,
        [NAMES.BMP_BTR]: 22574,
        [NAMES.ARTA]: 28122,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36797,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49268
    },
    "May 23 2025": {
        [NAMES.TROOPS]: 978700,
        [NAMES.TANKS]: 10841,
        [NAMES.BMP_BTR]: 22575,
        [NAMES.ARTA]: 28165,
        [NAMES.PPO]: 1167,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 36945,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49407
    },
    "May 24 2025": {
        [NAMES.TROOPS]: 979830,
        [NAMES.TANKS]: 10852,
        [NAMES.BMP_BTR]: 22622,
        [NAMES.ARTA]: 28201,
        [NAMES.PPO]: 1169,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 37177,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49639
    },
    "May 25 2025": {
        [NAMES.TROOPS]: 980850,
        [NAMES.TANKS]: 10854,
        [NAMES.BMP_BTR]: 22633,
        [NAMES.ARTA]: 28269,
        [NAMES.PPO]: 1169,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 37367,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49751
    },
    "May 26 2025": {
        [NAMES.TROOPS]: 981850,
        [NAMES.TANKS]: 10858,
        [NAMES.BMP_BTR]: 22641,
        [NAMES.ARTA]: 28320,
        [NAMES.PPO]: 1171,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 37631,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49843
    },
    "May 27 2025": {
        [NAMES.TROOPS]: 982840,
        [NAMES.TANKS]: 10860,
        [NAMES.BMP_BTR]: 22642,
        [NAMES.ARTA]: 28337,
        [NAMES.PPO]: 1171,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 37853,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49907
    },
    "May 28 2025": {
        [NAMES.TROOPS]: 983890,
        [NAMES.TANKS]: 10864,
        [NAMES.BMP_BTR]: 22644,
        [NAMES.ARTA]: 28355,
        [NAMES.PPO]: 1171,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 37918,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 49959
    },
    "May 29 2025": {
        [NAMES.TROOPS]: 984940,
        [NAMES.TANKS]: 10864,
        [NAMES.BMP_BTR]: 22645,
        [NAMES.ARTA]: 28386,
        [NAMES.PPO]: 1171,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 37999,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50015
    },
    "May 30 2025": {
        [NAMES.TROOPS]: 986080,
        [NAMES.TANKS]: 10865,
        [NAMES.BMP_BTR]: 22647,
        [NAMES.ARTA]: 28421,
        [NAMES.PPO]: 1172,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 38070,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50089
    },
    "May 31 2025": {
        [NAMES.TROOPS]: 987330,
        [NAMES.TANKS]: 10867,
        [NAMES.BMP_BTR]: 22652,
        [NAMES.ARTA]: 28475,
        [NAMES.PPO]: 1173,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 38215,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50198
    },
    "Jun 01 2025": {
        [NAMES.TROOPS]: 988560,
        [NAMES.TANKS]: 10872,
        [NAMES.BMP_BTR]: 22656,
        [NAMES.ARTA]: 28527,
        [NAMES.PPO]: 1173,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 38366,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50325
    },
    "Jun 02 2025": {
        [NAMES.TROOPS]: 989700,
        [NAMES.TANKS]: 10874,
        [NAMES.BMP_BTR]: 22663,
        [NAMES.ARTA]: 28575,
        [NAMES.PPO]: 1175,
        [NAMES.JETS]: 372,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 38622,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50462
    },
    "Jun 03 2025": {
        [NAMES.TROOPS]: 990800,
        [NAMES.TANKS]: 10881,
        [NAMES.BMP_BTR]: 22671,
        [NAMES.ARTA]: 28623,
        [NAMES.PPO]: 1176,
        [NAMES.JETS]: 384,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 38748,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50607
    },
    "Jun 04 2025": {
        [NAMES.TROOPS]: 991820,
        [NAMES.TANKS]: 10884,
        [NAMES.BMP_BTR]: 22678,
        [NAMES.ARTA]: 28711,
        [NAMES.PPO]: 1176,
        [NAMES.JETS]: 413,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 38924,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50730
    },
    "Jun 05 2025": {
        [NAMES.TROOPS]: 992750,
        [NAMES.TANKS]: 10887,
        [NAMES.BMP_BTR]: 22680,
        [NAMES.ARTA]: 28750,
        [NAMES.PPO]: 1177,
        [NAMES.JETS]: 413,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 39019,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50812
    },
    "Jun 06 2025": {
        [NAMES.TROOPS]: 993910,
        [NAMES.TANKS]: 10889,
        [NAMES.BMP_BTR]: 22685,
        [NAMES.ARTA]: 28794,
        [NAMES.PPO]: 1180,
        [NAMES.JETS]: 413,
        [NAMES.HELI]: 336,
        [NAMES.UAV]: 39193,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 50913
    },
    "Jun 07 2025": {
        [NAMES.TROOPS]: 995030,
        [NAMES.TANKS]: 10904,
        [NAMES.BMP_BTR]: 22737,
        [NAMES.ARTA]: 28850,
        [NAMES.PPO]: 1181,
        [NAMES.JETS]: 413,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 39493,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51079
    },
    "Jun 08 2025": {
        [NAMES.TROOPS]: 996150,
        [NAMES.TANKS]: 10911,
        [NAMES.BMP_BTR]: 22748,
        [NAMES.ARTA]: 28892,
        [NAMES.PPO]: 1183,
        [NAMES.JETS]: 414,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 39651,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51225
    },
    "Jun 09 2025": {
        [NAMES.TROOPS]: 997120,
        [NAMES.TANKS]: 10915,
        [NAMES.BMP_BTR]: 22759,
        [NAMES.ARTA]: 28934,
        [NAMES.PPO]: 1183,
        [NAMES.JETS]: 414,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 39818,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51348
    },
    "Jun 10 2025": {
        [NAMES.TROOPS]: 998080,
        [NAMES.TANKS]: 10919,
        [NAMES.BMP_BTR]: 22768,
        [NAMES.ARTA]: 28982,
        [NAMES.PPO]: 1183,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40057,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51455
    },
    "Jun 11 2025": {
        [NAMES.TROOPS]: 999290,
        [NAMES.TANKS]: 10927,
        [NAMES.BMP_BTR]: 22783,
        [NAMES.ARTA]: 29016,
        [NAMES.PPO]: 1183,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40297,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51579
    },
    "Jun 12 2025": {
        [NAMES.TROOPS]: 1000340,
        [NAMES.TANKS]: 10933,
        [NAMES.BMP_BTR]: 22786,
        [NAMES.ARTA]: 29063,
        [NAMES.PPO]: 1184,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40435,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51715
    },
    "Jun 13 2025": {
        [NAMES.TROOPS]: 1001560,
        [NAMES.TANKS]: 10934,
        [NAMES.BMP_BTR]: 22791,
        [NAMES.ARTA]: 29105,
        [NAMES.PPO]: 1184,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40507,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51821
    },
    "Jun 14 2025": {
        [NAMES.TROOPS]: 1002690,
        [NAMES.TANKS]: 10937,
        [NAMES.BMP_BTR]: 22798,
        [NAMES.ARTA]: 29157,
        [NAMES.PPO]: 1185,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40586,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 51928
    },
    "Jun 15 2025": {
        [NAMES.TROOPS]: 1003860,
        [NAMES.TANKS]: 10937,
        [NAMES.BMP_BTR]: 22804,
        [NAMES.ARTA]: 29190,
        [NAMES.PPO]: 1186,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40709,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52017
    },
    "Jun 16 2025": {
        [NAMES.TROOPS]: 1005060,
        [NAMES.TANKS]: 10939,
        [NAMES.BMP_BTR]: 22811,
        [NAMES.ARTA]: 29208,
        [NAMES.PPO]: 1187,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40804,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52096
    },
    "Jun 17 2025": {
        [NAMES.TROOPS]: 1006120,
        [NAMES.TANKS]: 10940,
        [NAMES.BMP_BTR]: 22814,
        [NAMES.ARTA]: 29228,
        [NAMES.PPO]: 1187,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 40981,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52175
    },
    "Jun 18 2025": {
        [NAMES.TROOPS]: 1007160,
        [NAMES.TANKS]: 10947,
        [NAMES.BMP_BTR]: 22845,
        [NAMES.ARTA]: 29265,
        [NAMES.PPO]: 1187,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 41165,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52312
    },
    "Jun 19 2025": {
        [NAMES.TROOPS]: 1008240,
        [NAMES.TANKS]: 10951,
        [NAMES.BMP_BTR]: 22853,
        [NAMES.ARTA]: 29328,
        [NAMES.PPO]: 1187,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 41229,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52420
    },
    "Jun 20 2025": {
        [NAMES.TROOPS]: 1009330,
        [NAMES.TANKS]: 10954,
        [NAMES.BMP_BTR]: 22860,
        [NAMES.ARTA]: 29374,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 41299,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52501
    },
    "Jun 21 2025": {
        [NAMES.TROOPS]: 1010390,
        [NAMES.TANKS]: 10955,
        [NAMES.BMP_BTR]: 22865,
        [NAMES.ARTA]: 29393,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 41422,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52617
    },
    "Jun 22 2025": {
        [NAMES.TROOPS]: 1011490,
        [NAMES.TANKS]: 10964,
        [NAMES.BMP_BTR]: 22867,
        [NAMES.ARTA]: 29432,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 41579,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52734
    },
    "Jun 23 2025": {
        [NAMES.TROOPS]: 1012500,
        [NAMES.TANKS]: 10965,
        [NAMES.BMP_BTR]: 22872,
        [NAMES.ARTA]: 29490,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 41717,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52861
    },
    "Jun 24 2025": {
        [NAMES.TROOPS]: 1013700,
        [NAMES.TANKS]: 10966,
        [NAMES.BMP_BTR]: 22879,
        [NAMES.ARTA]: 29511,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 42915,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 52961
    },
    "Jun 25 2025": {
        [NAMES.TROOPS]: 1014650,
        [NAMES.TANKS]: 10967,
        [NAMES.BMP_BTR]: 22885,
        [NAMES.ARTA]: 29569,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 42046,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53084
    },
    "Jun 26 2025": {
        [NAMES.TROOPS]: 1015750,
        [NAMES.TANKS]: 10968,
        [NAMES.BMP_BTR]: 22892,
        [NAMES.ARTA]: 29617,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 42153,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53195
    },
    "Jun 27 2025": {
        [NAMES.TROOPS]: 1016720,
        [NAMES.TANKS]: 10969,
        [NAMES.BMP_BTR]: 22896,
        [NAMES.ARTA]: 29630,
        [NAMES.PPO]: 1188,
        [NAMES.JETS]: 416,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 42240,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53284
    },
    "Jun 28 2025": {
        [NAMES.TROOPS]: 1017720,
        [NAMES.TANKS]: 10970,
        [NAMES.BMP_BTR]: 22908,
        [NAMES.ARTA]: 29665,
        [NAMES.PPO]: 1189,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 42477,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53415
    },
    "Jun 29 2025": {
        [NAMES.TROOPS]: 1018940,
        [NAMES.TANKS]: 10976,
        [NAMES.BMP_BTR]: 22915,
        [NAMES.ARTA]: 29689,
        [NAMES.PPO]: 1189,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 337,
        [NAMES.UAV]: 42624,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53508
    },
    "Jun 30 2025": {
        [NAMES.TROOPS]: 1020010,
        [NAMES.TANKS]: 10980,
        [NAMES.BMP_BTR]: 22922,
        [NAMES.ARTA]: 29718,
        [NAMES.PPO]: 1190,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 42796,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53593
    },
    "Jul 01 2025": {
        [NAMES.TROOPS]: 1020980,
        [NAMES.TANKS]: 10983,
        [NAMES.BMP_BTR]: 22928,
        [NAMES.ARTA]: 29754,
        [NAMES.PPO]: 1190,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 42940,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53696
    },
    "Jul 02 2025": {
        [NAMES.TROOPS]: 1022090,
        [NAMES.TANKS]: 10985,
        [NAMES.BMP_BTR]: 22931,
        [NAMES.ARTA]: 29794,
        [NAMES.PPO]: 1191,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 43013,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53786
    },
    "Jul 03 2025": {
        [NAMES.TROOPS]: 1023090,
        [NAMES.TANKS]: 10986,
        [NAMES.BMP_BTR]: 22936,
        [NAMES.ARTA]: 29815,
        [NAMES.PPO]: 1191,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 43098,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53887
    },
    "Jul 04 2025": {
        [NAMES.TROOPS]: 1024210,
        [NAMES.TANKS]: 10988,
        [NAMES.BMP_BTR]: 22946,
        [NAMES.ARTA]: 29865,
        [NAMES.PPO]: 1191,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 43303,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 53999
    },
    "Jul 05 2025": {
        [NAMES.TROOPS]: 1025260,
        [NAMES.TANKS]: 10990,
        [NAMES.BMP_BTR]: 22953,
        [NAMES.ARTA]: 29921,
        [NAMES.PPO]: 1191,
        [NAMES.JETS]: 420,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 43609,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54148
    },
    "Jul 06 2025": {
        [NAMES.TROOPS]: 1026440,
        [NAMES.TANKS]: 10992,
        [NAMES.BMP_BTR]: 22956,
        [NAMES.ARTA]: 29960,
        [NAMES.PPO]: 1192,
        [NAMES.JETS]: 421,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 43825,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54252
    },
    "Jul 07 2025": {
        [NAMES.TROOPS]: 1027540,
        [NAMES.TANKS]: 10995,
        [NAMES.BMP_BTR]: 22963,
        [NAMES.ARTA]: 29993,
        [NAMES.PPO]: 1192,
        [NAMES.JETS]: 421,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 44058,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54370
    },
    "Jul 08 2025": {
        [NAMES.TROOPS]: 1028610,
        [NAMES.TANKS]: 10995,
        [NAMES.BMP_BTR]: 22967,
        [NAMES.ARTA]: 30034,
        [NAMES.PPO]: 1192,
        [NAMES.JETS]: 421,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 44230,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54456
    },
    "Jul 09 2025": {
        [NAMES.TROOPS]: 1029660,
        [NAMES.TANKS]: 11000,
        [NAMES.BMP_BTR]: 22969,
        [NAMES.ARTA]: 30102,
        [NAMES.PPO]: 1193,
        [NAMES.JETS]: 421,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 44457,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54575
    },
    "Jul 10 2025": {
        [NAMES.TROOPS]: 1030580,
        [NAMES.TANKS]: 11011,
        [NAMES.BMP_BTR]: 22972,
        [NAMES.ARTA]: 30140,
        [NAMES.PPO]: 1193,
        [NAMES.JETS]: 421,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 44781,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54656
    },
    "Jul 11 2025": {
        [NAMES.TROOPS]: 1031620,
        [NAMES.TANKS]: 11013,
        [NAMES.BMP_BTR]: 22979,
        [NAMES.ARTA]: 30163,
        [NAMES.PPO]: 1193,
        [NAMES.JETS]: 421,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 45003,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54732
    },
    "Jul 12 2025": {
        [NAMES.TROOPS]: 1032690,
        [NAMES.TANKS]: 11013,
        [NAMES.BMP_BTR]: 22980,
        [NAMES.ARTA]: 30194,
        [NAMES.PPO]: 1193,
        [NAMES.JETS]: 421,
        [NAMES.HELI]: 340,
        [NAMES.UAV]: 45248,
        [NAMES.SHIPS]: 29,
        [NAMES.AUTO]: 54822
    }
};
